import RecordList from "../components/RecordList";
function PaymentsPage() { return <RecordList title="Payments" endpoint="/payments" columns={[["vendorName", "Vendor"], ["source", "Source"], ["destination", "Destination"], ["numberOfTrips", "Trips"], ["totalAmount", "Total"], ["paymentStatus", "Status"]]} />; }
export default PaymentsPage;
